<template>
  <Teleport to="body">
    <div class="modal-overlay" @mousedown.self="closeModal">
      <dialog class="card modal-content">
        <h3 class="modal-title">Настройки дублирования</h3>

        <form @submit.prevent="confirmDuplicate">
          <div class="form">
            <div class="modal-options">
              <div
                v-for="option in options"
                :key="option.id"
                class="option-item"
              >
                <div class="item-top">
                  <base-checkbox
                    class="top-checkbox"
                    v-model="selectedOptions[option.id]"
                  ></base-checkbox>
                  <span class="top-title">{{ option.label }}</span>
                </div>

                <p
                  v-if="option.description"
                  class="option-description"
                >
                  {{ option.description }}
                </p>
              </div>
            </div>
          </div>

          <div class="form-actions">
            <base-primary-button type="submit" class="form-btn">
              Дублировать
            </base-primary-button>
            <base-button
              class="form-btn"
              type="button"
              @click="closeModal"
            >
              Отмена
            </base-button>
          </div>
        </form>
      </dialog>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: "DuplicateModal",
  props: {
    options: {
      type: Array,
      required: true,
    },
    initialSelected: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedOptions: { ...this.initialSelected },
    };
  },
  methods: {
    toggleOption(optionId) {
      this.selectedOptions[optionId] =
        !this.selectedOptions[optionId];
    },

    confirmDuplicate() {
      this.$emit("confirm", { ...this.selectedOptions });
    },

    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.form {
  display: flex;
  flex-direction: column;
  margin-bottom: var(--base-in-indent);
}

.modal-description {
  margin-bottom: var(--base-in-indent);
  color: #666;
}

.modal-options {
  display: flex;
  flex-direction: column;
  gap: var(--base-in-indent);
}

.item-top {
  display: flex;
  align-items: flex-end;
}

.option-description {
  margin-top: 10px;
  color: #666;
  font-style: italic;
}
</style>
